import OtpInput from 'react-otp-input';
import React, { useEffect, useState } from 'react';
import { sendOTP, verifyOTP } from '../../../../../../redux/features/User';
import { toast } from 'material-react-toastify';
import { loginPageStyles } from '../../../../../../styles';
import { Button, Box, Link } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Toast as CustomToast } from '../../../../../../Components';
import Timer from '../Timer';

const textStyle = {
  fontFamily: 'Mulish',
  fontSize: '13px',
  lineHeight: '16px',
};

export const OTPVerification = ({ phoneNumber, setStep }) => {
  const classes = loginPageStyles();
  const dispatch = useDispatch();
  const [code, setCode] = useState('');
  const [verification, setVerification] = useState(false);
  const [timesOut, setTimesOut] = useState(false);
  const [time, setTime] = useState(2 * 60 * 1000);
  const rider = useSelector((state) => state.userReducer.rider);

  useEffect(() => {
    if (code.length === 6 && rider.id) {
      setVerification(true);
    } else {
      setVerification(false);
    }
  }, [code, rider.id]);
  const handleChange = (code) => setCode(code);
  const verifyOtp = () => {
    const body = {
      id: rider?.id,
      params: {
        otp: code,
      },
    };
    dispatch(verifyOTP(body))
      .unwrap()
      .then(() => {
        setStep(3);
      })
      .catch((error) => {
        toast(<CustomToast severity="warning" message={error.message} />, {
          closeButton: false,
        });
      });
  };
  const titleStyle = {
    fontFamily: 'Mukta',
    fontSize: '24px',
    lineHeight: '31px',
    fontWeight: '700',
    letterSpacing: '-0.01em',
    color: '#111111',
  };
  return (
    <>
      <Box sx={{ mb: '16px' }} className={classes.heading10} style={titleStyle}>
        Verification
      </Box>
      <Box
        className={classes.heading}
        sx={{
          mb: '49px',
          textAlign: 'center',
          fontSize: '15px',
          lineHeight: '19px',
          color: '#111111',
          maxWidth: '318px',
        }}
      >
        Enter the verification code we just sent to your phone number
      </Box>
      <Box sx={{ mx: 'auto', mb: '18px' }}>
        <OtpInput
          value={code}
          onChange={handleChange}
          numInputs={6}
          separator={
            <span
              style={{
                width: '21px',
                display: 'flex',
                justifyContent: 'center',
                alignContent: 'center',
                textAlign: 'center',
              }}
            ></span>
          }
          isInputNum={true}
          shouldAutoFocus={true}
          inputStyle={{
            border: 'none',
            borderBottom: '1px solid #054E8B',
            textAlign: 'center',
            width: '29px',
            fontSize: '12px',
            color: '#000',
            caretColor: 'blue',
          }}
          focusStyle={{
            border: 'none',
            borderBottom: '1px solid #054E8B',
            outline: 'none',
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center',
            textAlign: 'center',
          }}
        />
      </Box>
      <Box
        style={textStyle}
        sx={{ color: '#111111', textAlign: 'center', mb: '19px' }}
      >
        If you didn&apos;t receive a code.&nbsp;
        <Link
          component="button"
          onClick={() => {
            const body = {
              riders: { contact_number: `+${phoneNumber}` },
            };
            dispatch(sendOTP(body))
              .unwrap()
              .then(() => {
                toast(<CustomToast severity="success" message="OTP Resent" />, {
                  closeButton: false,
                });
                setTimesOut(false);
                setTime(2 * 60 * 1000);
              })
              .catch((error) => {
                toast(
                  <CustomToast
                    severity="warning"
                    message={error.message || 'Something went wrong'}
                  />,
                  { closeButton: false }
                );
              });
          }}
          sx={{
            display: 'inline',
            color: timesOut ? '#054E8B' : '#8493AE',
            textDecorationColor: timesOut ? '#054E8B' : '#8493AE',
          }}
          style={textStyle}
          classes={{ disabled: classes.disabledButton }}
          disabled={!timesOut ? true : false}
        >
          Resend
        </Link>
        <Timer time={time} setTime={setTime} setTimesOut={setTimesOut} />
      </Box>
      <Box width="78%">
        <Button
          onClick={verifyOtp}
          disabled={!verification}
          variant="text"
          className={classes.buttonStyle}
          sx={{
            bgcolor: '#054E8B',
            py: '4px',
            ':hover': { bgcolor: '#054E8B' },
          }}
        >
          Verify
        </Button>
      </Box>
    </>
  );
};

OTPVerification.propTypes = {
  phoneNumber: PropTypes.string.isRequired,
  setStep: PropTypes.func.isRequired,
};
export default OTPVerification;
